module.exports = {
    //Common Button
    "ASM_BTN_SEARCH": "ค้นหา",
    "ASM_BTN_CLEAR": "ล้างข้อมูล",
    "ASM_BTN_ADD": "เพิ่ม",

    "ASM_ACTIVE": "ใช้งาน",
    "ASM_INACTIVE": "ไม่ใช้งาน",
}
